import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'group', 'colours', 'back', 'radio' ];
  static values = { delay: { type: Number, default: 130 } }

  connect(){
    this.hideBeltGroups();
    // Match regardless of form scope (student[belt] on the account editor,
    // profile[belt] in anonymous onboarding).
    const beltInput = this.element.querySelector('input[name$="[belt]"]:checked')

    if (beltInput?.value) {
      const [colour, grade] = beltInput.value.split('.').map(Number);
      const beltGroupIndex = colour - 1;
      this.selectColour(beltGroupIndex);
      // Restore the prior selection without auto-advancing — this is a back
      // navigation landing on the belt step, not a fresh tap.
      this.selectGrade(beltGroupIndex, grade);
    }
  }

  proxiedSelectColour(e){
    this.selectColour(e.currentTarget.dataset.beltIndex)
  }

  selectColour(beltGroupIndex){
    this.hideBeltGroups();
    this.groupTargets[beltGroupIndex].classList.remove('hidden');
    this.coloursTarget.classList.add('hidden');
    this.backTarget.classList.remove('invisible');
    document.getElementById('previous_step_link').classList.add('hidden');
  }

  proxiedSelectGrade(e){
    this.selectGrade(e.currentTarget.dataset.beltIndex, e.currentTarget.dataset.gradeIndex);
    // A grade tap is the final answer for this single-question step — confirm
    // the selection visually, then advance (no Next button).
    this.advance();
  }

  selectGrade(beltGroupIndex, gradeIndex) {
    this.element.querySelectorAll('.belt-picker__belt-option').forEach(function(element){
      element.classList.add('opacity-50');
    });
    this.groupTargets[beltGroupIndex].querySelectorAll('.belt-picker__belt-option')[gradeIndex].classList.remove('opacity-50');
  }

  advance() {
    setTimeout(() => {
      if (typeof this.element.requestSubmit === "function") {
        this.element.requestSubmit();
      } else {
        this.element.submit();
      }
    }, this.delayValue);
  }

  hideBeltGroups() {
    this.groupTargets.forEach(function(element){
      element.classList.add('hidden');
    });
  }

  backToBeltSelection(){
    this.hideBeltGroups();
    this.coloursTarget.classList.remove('hidden');
    this.backTarget.classList.add('invisible');
    document.getElementById('previous_step_link').classList.remove('hidden');
    this.resetSelections();
  }

  resetSelections() {
    this.element.querySelectorAll('.belt-picker__belt-option').forEach(function(element){
      element.classList.remove('opacity-50');
    });
    this.radioTargets.forEach(function(radio){
      radio.checked = false;
    });
  }
}
